import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export abstract class BetalningSkogsvardBaseCommand extends BasicCommand<BetalningSkogsvardBaseCommand> {
    betalningSkogsvardId: number;
    kontraktGuid: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "BetalningSkogsvard";

    get primaryKey(): IBetalningSkogsvardPrimaryKey {
        return {
            betalningSkogsvardId: this.betalningSkogsvardId,
            kontraktGuid: this.kontraktGuid
        };
    }

    constructor(kontraktGuid: string,  betalningSkogsvardId: number, $type: string, commandType: CommandType) {
        super($type, BetalningSkogsvardBaseCommand.$groupKey, commandType);
        this.betalningSkogsvardId = betalningSkogsvardId;
        this.kontraktGuid = kontraktGuid;
    }
}

export interface IBetalningSkogsvardPrimaryKey extends IPrimaryKey<IBetalningSkogsvardPrimaryKey> {
    betalningSkogsvardId: number;
    kontraktGuid: string;
}
